export const defaults = {
    brandInfo: {
        disclaimer: "All information collected in this application is required to properly pair you with an approval center. This allows us to locate the closest and best approval center to submit your application. Your information will only be shared with this approval center. The approval center will be able to contact you if required regarding your pre-approval. Our average APR % ranges between 0% & 29.99%.",
    },
    twilioVerifyMethods: ["sms", "email", "call"],
    twilioVerifyRequired: false,
};